import { Button, Flex, Form, Input, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { mdlNotConfirm } from "../../../models/domain/NotConfirm";
import { NotConfirmSelect } from "../../common/NotConfirmSelect";
import { useMutation } from "react-query";
import { DefinitionService } from "../../../services/DefinitionService";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../../utils/ObjectHelper";
import { useState } from "react";
import { mdlSystemMarket } from "../../../models/domain/SystemMarket";
import TextArea from "antd/es/input/TextArea";

export type NotConfirmDetailProps = {
    hotelId?: string;
    callback?: Function;
}

export const NotConfirmDetail = (props: NotConfirmDetailProps) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const [templateList, setTemplateList] = useState<mdlNotConfirm[]>();
    const [isTemplate, setIsTemplate] = useState<boolean>();

    const { mutateAsync: saveNotConfirm, isLoading: mutateLoading, data: mutateData } = useMutation(
        async (data: mdlNotConfirm) => {
            if (data.notConfirmMessageTemplateId) {
                return DefinitionService.NotConfirmAdd({
                    name: data.name,
                    description: data.code,
                    hotelId: data.hotelId,
                    notConfirmTemplateId: data.notConfirmMessageTemplateId
                })
            }
            else {
                return DefinitionService.NotConfirmCreate({
                    code: data.code,
                    name: data.name,
                    hotelId: data.hotelId
                });
            }
        },
        {
            onMutate(variables) {
                variables.hotelId = props.hotelId;
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success && data.body) {
                    if (data.body.isSuccessful === true) {
                        toast.success(t("common.success"));
                        form.resetFields();
                        props.callback && props.callback();
                    }
                    else {
                        toast.error(data.body.message);
                    }
                }
                else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const handleTemplateSelection = (value: string) => {
        const selectedTemplate = templateList?.find((template) => template.notConfirmMessageTemplateId === value);
        if (selectedTemplate) {
            form.setFieldsValue({ notConfirmMessageTemplateId: value, code: selectedTemplate.code, name: selectedTemplate.name });
            setIsTemplate(true);
        }
    }

    const onTemplateLoad = (templates: mdlSystemMarket[]) => {
        setTemplateList(templates);
    }

    const handleTemplateClear = () => {
        setIsTemplate(false);
        form.resetFields();
    }

    return (
        <>
            <Spin spinning={mutateLoading}>
                <Form
                    form={form}
                    name="notConfirmForm"
                    layout="vertical"
                    onFinish={async (values) => await saveNotConfirm(values)}
                    autoComplete="off"
                >
                    <Form.Item
                        name="notConfirmMessageTemplateId"
                        label={t("definitions.notConfirm.notConfirmReasonTemplate")}
                    >
                        <NotConfirmSelect onLoad={onTemplateLoad} onChange={handleTemplateSelection} onClear={handleTemplateClear} />
                    </Form.Item>
                    <Form.Item
                        label={t("definitions.notConfirm.code")}
                        name="code"
                    >
                        <Input disabled={isTemplate} />
                    </Form.Item>
                    <Form.Item
                        label={t("definitions.notConfirm.name")}
                        name="name"
                    >
                        <TextArea disabled={isTemplate} rows={2} />
                    </Form.Item>

                    <Form.Item>
                        <Flex align={"center"} justify="flex-end">
                            <Button type="primary" htmlType="submit">{t("common.save")}</Button>
                        </Flex>

                    </Form.Item>
                </Form>
            </Spin>
        </>
    )
}